export type RewardPlan = {
  level: string;
  sales: string;
  bonus: string;
};

export type Benefit = {
  icon: string;
  title: string;
  text: string;
};

export type Campaign = {
  slug: string;
  title: string;
  subtitle: string;
  primaryCta: string;
  secondaryCta: string;
  phone: string;
  callUrl: string;
  plans: RewardPlan[];
  benefits: Benefit[];
  faqs: Array<{
    question: string;
    answer: string;
  }>;
};

export const campaigns: Record<string, Campaign> = {
  partner: {
    slug: "partner",
    title: "تا ۶۵ میلیون تومان پاداش نقدی با فروش خدمات سفر معین درباری بگیر",
    subtitle:
      "هتل، تور و پرواز بفروش - بدون نیاز به سایت یا پنل؛ فقط مشتری بیار، ما رزرو و تسویه را انجام می‌دهیم",
    primaryCta: "تماس برای شروع همکاری",
    secondaryCta: "مشاهده پلن پاداش‌ها",
    phone: "02191098821",
    callUrl: "tel:+982191098821",
    plans: [
      {
        level: "سطح 1",
        sales: "200 میلیون",
        bonus: "2 میلیون تومان پاداش نقدی",
      },
      {
        level: "سطح 2",
        sales: "400 میلیون",
        bonus: "4.5 میلیون تومان پاداش نقدی",
      },
      {
        level: "سطح 3",
        sales: "800 میلیون",
        bonus: "10.5 میلیون تومان پاداش نقدی",
      },
      {
        level: "سطح 4",
        sales: "1.6 میلیارد",
        bonus: "25 میلیون تومان پاداش نقدی",
      },
      {
        level: "VIP",
        sales: "3.2 میلیارد+",
        bonus: "65 میلیون تومان پاداش نقدی",
      },
    ],
    benefits: [
      {
        icon: "✓",
        title: "پرداخت سریع پاداش",
        text: "بعد از قطعی شدن فروش، پاداش نقدی طبق سطح فروش به حسابت اضافه می‌شود.",
      },
      {
        icon: "٪",
        title: "خدمات کامل سفر",
        text: "برای فروش هتل، تور و پرواز پیشنهادهای قابل ارائه داری.",
      },
      {
        icon: "☎",
        title: "پشتیبانی مستقیم",
        text: "برای هماهنگی فروش، رزرو و پیگیری مشتری تماس مستقیم برقرار می‌شود.",
      },
      {
        icon: "✦",
        title: "بدون نیاز به پنل یا سایت",
        text: "تو مشتری معرفی می‌کنی و تیم ما رزرو و خدمات را جلو می‌برد.",
      },
      {
        icon: "↗",
        title: "شروع فوری",
        text: "بدون آماده‌سازی فنی، می‌تونی از همان روز فروش را شروع کنی.",
      },
    ],
    faqs: [
      {
        question: "بازه زمانی محاسبه پلن تارگت فروش چگونه تعیین می‌شود؟",
        answer: "از لحظه ثبت نام تا پایان تابستان.",
      },
      {
        question: "حجم فروش در پلن تارگت فروش چگونه محاسبه می‌شود؟",
        answer: "بر اساس مجموع فروش تایید شده محصولات مشمول طرح محاسبه می‌شود.",
      },
      {
        question: "درآمد حاصل از دستیابی به تارگت فروش چه زمانی به حساب کاربری واریز می‌شود؟",
        answer: "زمان رسیدن به اولین تارگت فروش.",
      },
      {
        question: "آیا بابت خرید محصولات معین درباری، علاوه بر درآمد تارگت فروش، کمیسیون نیز تعلق می‌گیرد؟",
        answer: "بله. کمیسیون‌ها به قوت خود باقی است.",
      },
      {
        question: "کدام هتل‌ها در فهرست هتل‌های گارانتی معین درباری قرار دارند؟",
        answer:
          "مشهد: سی و سه پل، امینیان، معین درباری، اخوی زاده، ذاکر. کیش: آرامیس، آرامیس پلاس، صدف.",
      },
      {
        question: "میزان کمیسیون رزرو هتل چقدر است؟",
        answer: "هتل‌های مشهد ۱۵ درصد و هتل‌های کیش ۱۰ درصد.",
      },
      {
        question: "میزان کمیسیون رزرو هتل های شناور چقدر است؟",
        answer: "بین ۷ الی ۱۵ درصد متغیر است.",
      },
      {
        question: "میزان کمیسیون خرید بلیت پرواز چقدر است؟",
        answer: "طبق شرایط فروش اعلام می‌شود.",
      },
      {
        question: "میزان کمیسیون خرید تور چقدر است؟",
        answer: "طبق شرایط فروش اعلام می‌شود.",
      },
      {
        question: "آیا خرید بلیت پرواز در محاسبه حجم فروش تأثیر دارد؟",
        answer: "بله، شامل تارگت می‌شود.",
      },
      {
        question: "آیا خرید تور در محاسبه حجم فروش تأثیر دارد؟",
        answer: "بله، شامل تارگت می‌شود.",
      },
      {
        question: "آیا حجم فروش صرفاً بر اساس رزرو هتل‌های گارانتی معین درباری محاسبه می‌شود؟",
        answer: "خیر، تمامی هتل‌ها، پروازها و تورها را شامل می‌شود.",
      },
      {
        question: "آیا مقصد سفر یا نوع محصول، در نحوه محاسبه حجم فروش و درآمد دریافتی تأثیر دارد؟",
        answer: "مقصد و نوع محصول تاثیری در حجم فروش و درآمد ندارد.",
      },
      {
        question: "آیا کانترهای فروش می‌توانند به‌صورت مستقل در پلن B2B معین درباری شرکت کنند؟",
        answer: "بله، کانترهای فروش می‌توانند به صورت مستقل شرکت کنند.",
      },
    ],
  },
};

export function getCampaign(slug: string) {
  return campaigns[slug] ?? null;
}
